import styled from 'styled-components'

// 데이터 출처 — 출처가 바뀌면 booksitout-server CLAUDE.md 의 출처 표시 목록과 함께 수정
const LibraryDataAttribution = () => {
    return (
        <DataAttribution className="text-secondary">
            도서관 정보: 국립중앙도서관 도서관 정보나루, 한국지능정보사회진흥원 전국도서관표준데이터
        </DataAttribution>
    )
}

const DataAttribution = styled.div`
    margin-top: 8px;
    font-size: 12px;
    text-align: center;
`

export default LibraryDataAttribution
